import { Layout } from './layout';

Layout.displayName = 'SkeletonBase';

export { Layout as Base };
